export const environment = {
  // base: 'http://localhost:3000',
  base: 'http://192.168.2.15:3000',
  // base: 'https://clockboss.herokuapp.com'
}